import { Layouts } from "react-grid-layout";
import { ItemLayoutsConfig } from "./types";

export function parseLayoutConfigToLayouyts(
  layoutsInfo: ItemLayoutsConfig,
  canEdit: boolean
): Layouts {
  const lgLayouts = layoutsInfo.layouts.lg
    ? layoutsInfo.layouts.lg.map(({ ["cardId"]: cardId, ...rest }) => ({
        ...rest,
        i: cardId,
        static: !canEdit,
      }))
    : [];
  const mdLayouts = layoutsInfo.layouts.md
    ? layoutsInfo.layouts.md.map(({ ["cardId"]: cardId, ...rest }) => ({
        ...rest,
        i: cardId,
        static: !canEdit,
      }))
    : [];
  const smLayouts = layoutsInfo.layouts.sm
    ? layoutsInfo.layouts.sm.map(({ ["cardId"]: cardId, ...rest }) => ({
        ...rest,
        i: cardId,
        static: !canEdit,
      }))
    : [];
  const xsLayouts = layoutsInfo.layouts.xs
    ? layoutsInfo.layouts.xs.map(({ ["cardId"]: cardId, ...rest }) => ({
        ...rest,
        i: cardId,
        static: !canEdit,
      }))
    : [];
  const xxsLayouts = layoutsInfo.layouts.xxs
    ? layoutsInfo.layouts.xxs.map(({ ["cardId"]: cardId, ...rest }) => ({
        ...rest,
        i: cardId,
        static: !canEdit,
      }))
    : [];

  const layouts: Layouts = {
    lg: lgLayouts,
    md: mdLayouts,
    sm: smLayouts,
    xs: xsLayouts,
    xxs: xxsLayouts,
  };
  return layouts;
}
export function parseLayoutsToLayoutConfig(
  layouts: Layouts,
  layoutsConfigId: string
): ItemLayoutsConfig {
  const layoutsConfig: ItemLayoutsConfig = {
    id: layoutsConfigId,
    layouts: {
      lg: layouts.lg.map((layout) => ({
        cardId: layout.i,
        ...layout,
      })),
      md: layouts.md.map((layout) => ({
        cardId: layout.i,
        ...layout,
      })),
      sm: layouts.sm.map((layout) => ({
        cardId: layout.i,
        ...layout,
      })),
      xs: layouts.xs.map((layout) => ({
        cardId: layout.i,
        ...layout,
      })),
      xxs: layouts.xxs.map((layout) => ({
        cardId: layout.i,
        ...layout,
      })),
    },
  };
  return layoutsConfig;
}
